import { computed } from "vue";
import { useUserStore } from "@/store/useUserStore";

export const UserRole = Object.freeze({
  FULL_ACCESS: "FULL_ACCESS",
  AGENCY_GROUP_MANAGER: "AGENCY_GROUP_MANAGER",
  SCOPED_AGENCY: "SCOPED_AGENCY",
  NO_ACCESS: "NO_ACCESS",
});


export function computeRole(userStore) {
  const groups = userStore.groups ?? [];

  if (groups.includes("SocioDev") || groups.includes("Developer") || groups.includes("Admin")) {
    return UserRole.FULL_ACCESS;
  }
  if ((userStore.managedAgencyGroupUuids?.length ?? 0) > 0) {
    return UserRole.AGENCY_GROUP_MANAGER;
  }
  if ((userStore.agencyScopeUuids?.length ?? 0) > 0) {
    return UserRole.SCOPED_AGENCY;
  }
  return UserRole.NO_ACCESS;
}

export function hasSingleAgencyScope(userStore) {
  return (
    computeRole(userStore) === UserRole.SCOPED_AGENCY &&
    (userStore.agencyScopeUuids?.length ?? 0) === 1
  );
}

export function useUserRole() {
  const userStore = useUserStore();
  const effectiveRole = computed(() => computeRole(userStore));

  return {
    effectiveRole,
    isFullAccess: computed(() => effectiveRole.value === UserRole.FULL_ACCESS),
    isScopedAgency: computed(() => effectiveRole.value === UserRole.SCOPED_AGENCY),
    isAgencyGroupManager: computed(
      () => effectiveRole.value === UserRole.AGENCY_GROUP_MANAGER,
    ),
    isSingleAgencyScope: computed(() => hasSingleAgencyScope(userStore)),
    isNoAccess: computed(() => effectiveRole.value === UserRole.NO_ACCESS),
  };
}
